export default "__VITE_PUBLIC_ASSET__aed64cb4__"